import { Badge, Box, Grid, GridItem, Image } from "@chakra-ui/react";
import React, { useState } from "react";
import {
  Flex,
  Heading,
  Text,
  Stack,
  Switch,
  Button,
  Icon,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import {
  textSecondary,
  white,
  primaryAlt,
  color6,
  color4,
  color3,
  color2,
  color1,
  color5,
  whiteAlt,
  primary,
  secondary,
  color8,
} from "../../../../../utils/colors";
import useThemeColors from "../../../../../hooks/useThemeColors";
import { convertFromUSD } from "../../../../../utils/currency";
// import ModuleLimits from "./ModuleLimits";
import dayjs from "dayjs";
import { TbCheck } from "react-icons/tb";
import { FaBoltLightning, FaCcStripe } from "react-icons/fa6";
import {
  TbUser,
  TbUsers,
  TbMail,
  TbSettings,
  TbMessage,
  TbCash,
} from "react-icons/tb";
import { shade } from "polished";

const FeatureItem = ({ feature }) => {
  return (
    <Flex align="flex-start" gap={2}>
      <Icon as={TbCheck} color={whiteAlt} fontSize="1rem" />
      <Text color={whiteAlt} maxW="80%" fontWeight="500" fontSize="0.8rem">
        {feature}
      </Text>
    </Flex>
  );
};

const SubscriptionSelectedPlanInfo = ({
  subscription,
  isYearly,
  setIsYearly,
  closeHandler,
  selectedPlan,
  setSelectedPlan,
  currentCurrency,
}) => {
  const { t } = useTranslation();

  const currencies = ["USD", "EUR", "GBP"];

  const getCurrencySymbol = (code) => {
    const map = {
      EUR: "€",
      USD: "$",
      GBP: "£",
    };
    return map[code] || code;
  };

  const { textPrimaryMode, backgroundLightMode, newBorderMode } =
    useThemeColors();

  // STATE

  const getConvertedPrice = (usdValue) =>
    convertFromUSD(usdValue, currentCurrency);

  // LOG

  // console.log("subscription", subscription);

  return (
    <Box m="0rem 0 0" borderRadius="1rem" p="0rem" w="100%">
      <>
        <Text
          fontSize="0.875rem"
          fontWeight="600"
          color={textPrimaryMode}
          m="0 0 0.5rem"
        >
          {t("module.subscriptionInfo")}
        </Text>

        {/* NEW START */}
        <Box bg={backgroundLightMode} p="1.5rem" borderRadius="1rem">
          <Box
            w="100%"
            p="2.5rem 2rem"
            // border={`1px solid ${newBorderMode}`}
            // h="380px"
            borderRadius="1rem"
            textAlign="left"
            bg={white}
          >
            <Flex align="center" justify="space-between">
              <Heading
                fontSize="1.25rem"
                fontWeight="600"
                h="26px"
                color={textPrimaryMode}
              >
                {t(
                  `module.plan-${subscription.name}-${selectedPlan.key}-title`
                )}{" "}
                {/* {plan.title} */}
              </Heading>
              {selectedPlan.isMostPopular && (
                <Badge
                  p="0.25rem 1rem"
                  borderRadius="10rem"
                  bg={color8}
                  color={textPrimaryMode}
                  fontWeight="500"
                  variant="solid"
                >
                  {t("module.pricingMostPopular")}
                </Badge>
              )}
            </Flex>

            <Flex
              direction="column"
              gap="0.25rem"
              m="1.5rem 0"
              h="34px"
              // minH="4rem"
            >
              <Flex align="baseline" gap="0.5rem">
                {isYearly && selectedPlan.key !== "free" && (
                  <Text
                    fontSize="lg"
                    fontWeight="500"
                    color="gray.500"
                    textDecoration="line-through"
                  >
                    {getCurrencySymbol(currentCurrency)}{" "}
                    {getConvertedPrice(selectedPlan.priceUsdMonthly)}
                  </Text>
                )}

                <Text
                  fontSize="2rem"
                  fontWeight="600"
                  lineHeight="1"
                  color={textPrimaryMode}
                >
                  {getCurrencySymbol(currentCurrency)}{" "}
                  {isYearly
                    ? getConvertedPrice(selectedPlan.priceUsdAnnualMonthly)
                    : getConvertedPrice(selectedPlan.priceUsdMonthly)}
                </Text>
                <Text fontSize="0.8rem" fontWeight="500" color={textSecondary}>
                  {t("module.pricingPerMonth")}
                </Text>
              </Flex>

              {isYearly && (
                <Flex align="center">
                  <Text
                    fontSize="0.8rem"
                    color={textSecondary}
                    h="13px"
                    m="0rem 0 0"
                    fontWeight="500"
                  >
                    {selectedPlan.key !== "free" && (
                      <>
                        <Text as="span" mr={1}>
                          {t("module.pricingBilledAnnually")}
                        </Text>
                        {getCurrencySymbol(currentCurrency)}{" "}
                        {getConvertedPrice(selectedPlan.priceUsdAnnual)}
                      </>
                    )}
                  </Text>
                </Flex>
              )}
            </Flex>

            <Flex
              align="center"
              justify="flex-start"
              m={!isYearly ? "1.5rem 0 0" : "2.5rem 0 0"}
              transition="all 0.2s ease"
              fontSize="sm"
              fontWeight="500"
              color={textSecondary}
              gap="0.5rem"
              textAlign="left"
            >
              <Flex align="center">
                <Text fontWeight="500">
                  {t(
                    `module.plan-${subscription.name}-${selectedPlan.key}-description`
                  )}
                </Text>
              </Flex>
            </Flex>

            <Flex
              direction="column"
              gap="0.75rem"
              m="1.5rem 0 0"
              borderTop={`1px solid ${newBorderMode}`}
              pt="1.25rem"
            >
              {/* PLAN LIMITS START */}
              <Flex
                align="center"
                justify="space-between"
                fontSize="sm"
                fontWeight="500"
                color={textSecondary}
                gap="0.5rem"
                textAlign="left"
              >
                <Flex align="center">
                  <Image
                    src="/icons/treatment.svg"
                    opacity="0.6"
                    h="1rem"
                    position="relative"
                    top="-1px"
                    mr={1}
                  />

                  <Text fontWeight="500">
                    {selectedPlan.key !== "enterprise" ? (
                      <Text
                        as="span"
                        fontWeight="600"
                        color={textPrimaryMode}
                        mr={1}
                      >
                        {selectedPlan.limitCount}
                      </Text>
                    ) : (
                      <Text
                        as="span"
                        fontWeight="600"
                        color={textPrimaryMode}
                        mr={1}
                      >
                        &#8734;
                      </Text>
                    )}
                    {t(
                      `module.plan-${subscription.name}-${selectedPlan.key}-limit`,
                      {
                        limit: selectedPlan.limitCount,
                      }
                    )}
                  </Text>
                </Flex>
              </Flex>
              {/* PLAN LIMITS END */}

              {/* SECOND FEATURE START */}
              <Flex
                align="center"
                justify="space-between"
                fontSize="sm"
                fontWeight="500"
                color={textSecondary}
                gap="0.5rem"
                textAlign="left"
              >
                <Flex align="center">
                  <Icon
                    as={
                      selectedPlan.key === "enterprise"
                        ? TbUser
                        : selectedPlan.key === "premium"
                        ? TbUsers
                        : TbMail
                    }
                    color={textSecondary}
                    ml={0.5}
                    mr={1}
                  />

                  <Text fontWeight="500">
                    {selectedPlan.key === "free"
                      ? t("module.fixedLimitFree")
                      : selectedPlan.key === "premium"
                      ? t("module.fixedLimitPremium")
                      : t("module.fixedLimitEnterprise")}
                  </Text>
                </Flex>
              </Flex>
              {/* SECOND FEATURE END */}

              {/* THIRD FEATURE START */}

              <Flex
                align="center"
                justify="space-between"
                fontSize="sm"
                fontWeight="500"
                color={textSecondary}
                gap="0.5rem"
                textAlign="left"
              >
                <Flex align="center">
                  <Icon
                    as={
                      selectedPlan.key === "enterprise"
                        ? TbSettings
                        : selectedPlan.key === "premium"
                        ? TbMessage
                        : TbCash
                    }
                    color={textSecondary}
                    ml={0.5}
                    mr={1}
                  />

                  <Text fontWeight="500">
                    {selectedPlan.key === "free"
                      ? t("module.limitTextFree")
                      : selectedPlan.key === "premium"
                      ? t("module.limitTextPremium")
                      : t("module.limitTextEnterprise")}
                  </Text>
                </Flex>
              </Flex>
              {/* THIRD FEATURE END */}

              {/* AND MORE  */}
              <Flex
                align="center"
                justify="space-between"
                fontSize="sm"
                fontWeight="500"
                color={textSecondary}
                gap="0.5rem"
                textAlign="left"
              >
                <Flex align="center">
                  <Text fontWeight="500">{t("module.planAndMore")}</Text>
                </Flex>
              </Flex>
            </Flex>
          </Box>
          <Flex align="center" justify="center" p="1.25rem 0 0.5rem">
            <Text
              fontSize="0.8rem"
              fontWeight="500"
              color={textSecondary}
              onClick={closeHandler}
              textAlign="center"
              _hover={{ cursor: "pointer", color: primaryAlt }}
            >
              {t("module.viewAllPlans")}
            </Text>
          </Flex>

          {/* NEW END */}

          {/* MODULE */}

          {/* <Flex direction="column" w="100%" p="1.5rem 0 0">
          <Flex
            w="100%"
            align="flex-start"
            justify="center"
            direction="column"
            p="0rem 0"
          >
            <Flex align="center">
              <Icon
                as={FaCcStripe}
                color={secondary}
                fontSize="1.5rem"
                mr={2}
              />
              <Text color={textPrimaryMode} fontWeight="500" fontSize="0.8rem">
                {t("module.securePayment")}
              </Text>
            </Flex>
            <Text
              color={textSecondary}
              fontSize="xs"
              fontWeight="500"
              m="0.25rem 0 0"
              textAlign="left"
            >
              {t("module.securePaymentText")}
            </Text>
          </Flex>
        </Flex> */}
        </Box>
      </>
    </Box>
  );
};

export default SubscriptionSelectedPlanInfo;
